var map = {
	"./double_arrow_white.svg": "dd36",
	"./github-icon.svg": "cc4f",
	"./gmail-icon.svg": "fd53",
	"./linkedin_icon.svg": "e01c",
	"./quote-bg.jpg": "2380",
	"./soft-skills-image-1.jpg": "0838",
	"./soft-skills-image-2.jpg": "f84b",
	"./soft-skills-image-3.jpg": "c164",
	"./soft-skills-image-4.jpg": "b4f8",
	"./telegram-icon.svg": "0597"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "02f8";